import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SpinnerService } from './spinner.service';


@Component({
    selector: 'stm-spinner',
    templateUrl: './spinner.cmp.html',
    styles: [`
        .global-busy-indicator {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            height: 100%;
            background-color: rgba(0, 0, 1, .25);
            z-index: 2000;
        }
        
        .indicator {
            height: 10px;
            width: 100%;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
        }
        
        .progress {
            border-radius: 0;
            height: 10px;
        }
        
        .progress-bar {
            color: black;
        }
    `],
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent {
    private readonly spinnerService = inject(SpinnerService);

    readonly visible = this.spinnerService.visible;
}